"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = exports.Carousel = void 0;
var _mui = require("@ori-ui/mui");
var _presentationComponents = require("@ori/presentation-components");
const Root = exports.Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  margin: 'auto',
  maxWidth: 970,
  marginBottom: theme.spacing(6),
  [theme.breakpoints.up('sm')]: {
    marginBottom: theme.spacing(20)
  }
}));
const Carousel = exports.Carousel = (0, _mui.styled)(_presentationComponents.Carousel)(({
  theme
}) => ({
  [theme.breakpoints.up('lg')]: {
    margin: theme.spacing(0, -12)
  }
}));
